module.exports = __webpack_public_path__ + "static/media/Montserrat-ThinItalic.179f8e8d.woff";